import Api from "../../../services/Api";
import { sanitizeSerialPathParam } from "../../../lib/utils/apiValidation";

function fetchChargerStatus(serialNo, startTime, endTime) {
  const serial = sanitizeSerialPathParam(serialNo);
  return Api.get(
    `/service/iqevse-csms/charger/v1/presence/${serial}?start=${encodeURIComponent(startTime)}&end=${encodeURIComponent(endTime)}`
  );
}

function fetchChargerMatrix(serialNo, startTime, endTime, type) {
  const serial = sanitizeSerialPathParam(serialNo);
  let url = `/service/iqevse-csms/v1/opt-schedules/${serial}?start=${encodeURIComponent(startTime)}&end=${encodeURIComponent(endTime)}`;
  if (type) {
    url += `&scheduleOptimisationType=${encodeURIComponent(type)}`;
  }
  return Api.get(url);
}

function fetchPowerOfferings(serialNo, startTime, endTime) {
  const serial = sanitizeSerialPathParam(serialNo);
  return Api.get(
    `/service/evse_rollups/api/v1/ev_chargers/${serial}/power_offered?start=${encodeURIComponent(startTime)}&end=${encodeURIComponent(endTime)}`
  );
}

export { fetchChargerStatus, fetchChargerMatrix, fetchPowerOfferings };
